import React, { useEffect, useState } from 'react'
import StudentSidebar from '../StudentSidebar/StudentSidebar'
import StudentTestModal from './StudentTestModal'
import { Link } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import { getStudentCompletedAssListData, getStudentUpcomingAssListData } from '../../../Redux/action/StudentAction'
import Beatloader from '../../../Common/BeatLoader'
import { Modal, ModalBody, ModalHeader, ModalTitle, OverlayTrigger, Tooltip } from "react-bootstrap";

import { useFormik } from 'formik'
import * as Yup from "yup";
import axios from 'axios';
import toast from 'react-hot-toast';
import HourglassLoader from '../../../Common/HourglassLoader'


const host = process.env.REACT_APP_API_SERVER
const StudentMyAssignments = () => {
    const [showGradeModal, setShowGradeModal] = useState(false);
    const [gradeData, setgradeData] = useState({});
    const [loadgradeData, setloadgradeData] = useState(true);
    const handleGradeModalClick = (data) => {

        if (data?.question_type && !data?.marks_obtained?.marks) {
            return toast.error('Result In Process')
        }

        const dataCopy = { ...data };


        const result = calculateGrade(dataCopy?.total_marks, dataCopy?.marks_obtained?.marks);


        dataCopy.result = result;


        setgradeData(dataCopy);


        setShowGradeModal(true);
        setloadgradeData(false);

    };

    const [showObjectiveModal, setShowObjectiveModal] = useState(false);
    const [objectiveModalData, setObjectiveModalData] = useState({});
    const [loadObjectiveModalData, setloadObjectiveModalData] = useState(true);

    const handleObjectiveModalClick = (data) => {


        setObjectiveModalData(data);
        setShowObjectiveModal(true);
        setloadObjectiveModalData(false);
    };

    const [showSubjectiveModal, setShowSubjectiveModal] = useState(false);
    const [subjectiveModalData, setSubjectiveModalData] = useState({});
    const [loadSubjectiveModalData, setloadSubjectiveModalData] = useState(true);

    const handleSubjectiveModalClick = (data) => {


        setSubjectiveModalData(data);
        setShowSubjectiveModal(true);
        setloadSubjectiveModalData(false);
    };


    const [showObjectiveTestModal, setShowObjectiveTestModal] = useState(false);
    const [ObjectiveTestModalData, setObjectiveTestModalData] = useState([]);
    const [loadObjectiveTestModalData, setloadObjectiveTestModalData] = useState(true);

    const handleObjectiveTestModalClick = (data) => {


        setObjectiveTestModalData(data);
        setShowObjectiveModal(false);
        setShowObjectiveTestModal(true);
        setloadObjectiveTestModalData(false);
    };
    const handleClose = () => setShowObjectiveTestModal(false);

    // const questionsData = [
    //     {
    //         questionText: "In 2017, which player became the leading run scorer of all time in women's ODI cricket?",
    //         options: ["Stefanie Taylor", "Mithali Raj", "Suzie Bates", "Harmanpreet Kaur"],
    //     },
    //     {
    //         questionText: "What is the capital city of Australia?",
    //         options: ["Sydney", "Canberra", "Melbourne", "Brisbane"],
    //     },
    //     // Add more questions here
    // ];




    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getStudentUpcomingAssListData())
        dispatch(getStudentCompletedAssListData())
    }, []);

    const {
        loadingStudentCompletedAssListApi,
        StudentCompletedAssListApiData,
        StudentCompletedAssListApiError,

        loadingStudentUpcomingAssListApi,
        StudentUpcomingAssListApiData,
        StudentUpcomingAssListApiError
    } = useSelector(state => state?.StudentReducer);


    const formik = useFormik({
        initialValues: {
            assessment_id: '',
            assessment_file: null, // Use null to store a file object
        },
        validationSchema: Yup.object({
            assessment_file: Yup.mixed().required('Upload assessment file'), // Validate file upload
        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {
                setSubmitting(true);

                // Prepare FormData to include both the file and assessment ID
                const formData = new FormData();
                formData.append('assessment_file', values.assessment_file); // Add file
                formData.append('assessment_id', values.assessment_id); // Add ID

                const config = {
                    headers: {
                        "Content-Type": "multipart/form-data", // Required for file uploads
                        "x-auth-token": localStorage.getItem('student-token'),
                    },
                };



                const response = await axios.post(
                    `${ host }/api/student/assessment/submit-subjective`,
                    formData,
                    config
                );

                if (response.status === 200) {
                    setSubmitting(false);
                    toast.success("Test submitted successfully");
                    resetForm();
                    setShowSubjectiveModal(false);
                    dispatch(getStudentUpcomingAssListData());
                    dispatch(getStudentCompletedAssListData())
                } else {
                    setSubmitting(false);
                    toast.error(response.data.message);
                }
            } catch (error) {
                setSubmitting(false);
                console.error("Error:", error);
                toast.error(error.response.data.message);
            }
        },
    });

    const handleFileChange = (event, id) => {
        const file = event.target.files[0];
        formik.setFieldValue('assessment_file', file); // Set the selected file
        formik.setFieldValue('assessment_id', id); // Set the assessment ID
    };


    const date_diff_indays = function (date2) {
        const dt1 = new Date();
        const dt2 = new Date(date2);
        return Math.floor(
            (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
                Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
            (1000 * 60 * 60 * 24)
        );
    };

    function calculateGrade(totalMarks, obtainedMarks) {
        if (totalMarks <= 0) {
            throw new Error("Total marks must be greater than zero.");
        }

        // Calculate percentage
        const percentage = (obtainedMarks / totalMarks) * 100;

        // Determine grade and remarks
        let grade, remarks;

        if (percentage >= 90) {
            grade = "A+";
            remarks = "Excellent";
        } else if (percentage >= 80) {
            grade = "A";
            remarks = "Very Good";
        } else if (percentage >= 70) {
            grade = "B";
            remarks = "Good";
        } else if (percentage >= 60) {
            grade = "C";
            remarks = "Satisfactory";
        } else if (percentage >= 50) {
            grade = "D";
            remarks = "Needs Improvement";
        } else {
            grade = "F";
            remarks = "Fail";
        }

        // Return result as an object
        return {
            percentage: Math.ceil(percentage) + "%",
            grade,
            remarks
        };
    }


    const handleStartTestClick = (data) => {
        const currentDate = new Date();
        const assessmentDate = new Date(data?.assesment_date); // Convert string to Date object

        if (assessmentDate <= currentDate) {
            // Check question type and invoke the appropriate function
            data?.question_type ? handleSubjectiveModalClick(data) : handleObjectiveModalClick(data);
        } else {
            // Show a toast message if the test date is in the future
            toast.success(`Test will start on ${ assessmentDate.toDateString() }`);
        }
    };


    return (
        <div className='student-my-assignment'>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Assignment Test
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="my-student-sec">
                                    <ul className="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                                        {/* <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link active"
                                                id="mock-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#mock"
                                                type="button"
                                                role="tab"
                                                aria-controls="mock"
                                                aria-selected="true"
                                            >
                                                Mock Assignments
                                            </button>
                                        </li> */}
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link active"
                                                id="home-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#home"
                                                type="button"
                                                role="tab"
                                                aria-controls="home"
                                                aria-selected="true"
                                            >
                                                Upcoming
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="profile-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#profile"
                                                type="button"
                                                role="tab"
                                                aria-controls="profile"
                                                aria-selected="false"
                                            >
                                                Completed
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content my-student-tab-pane" id="myTabContent">
                                        <div
                                            className="tab-pane fade"
                                            id="mock"
                                            role="tabpanel"
                                            aria-labelledby="mock-tab"
                                        >
                                            <div className="my-schedule-detail-sec">
                                                {loadingStudentUpcomingAssListApi ?
                                                    <Beatloader />
                                                    :
                                                    <div className="row">
                                                        {StudentUpcomingAssListApiData?.length ?

                                                            <div className="col-lg-6 col-md-6 col-sm-6 mt-3 col-md-6">
                                                                <div
                                                                    className="card bg-light"
                                                                    style={{
                                                                        borderRadius: 10,
                                                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
                                                                    }}
                                                                >
                                                                    <div className="card-body p-3">
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <div>
                                                                                <span className="badge me-2 bg-danger text-white">
                                                                                    Objective
                                                                                </span>
                                                                                <span className="badge me-2 bg-success text-white">
                                                                                    Mock Assignment
                                                                                </span>
                                                                                <span className="badge me-2 bg-primary text-white">
                                                                                    Mathematics
                                                                                </span>
                                                                            </div>
                                                                            {/* 
                                                      <small class="text-muted"><i class="fas fa-clock"></i> Due
                                                          in 2 Days</small> */}
                                                                        </div>
                                                                        <h5 className="mb-1" style={{ fontWeight: "bold" }}>
                                                                            Surface Areas and Volumes
                                                                        </h5>
                                                                        <div className="d-flex justify-content-between">
                                                                            <small className="text-muted">Assign Date</small>
                                                                            <small className="text-muted">
                                                                                {" "}
                                                                                <strong>10 Nov 20</strong>
                                                                            </small>
                                                                        </div>
                                                                        <div className="d-flex justify-content-between">
                                                                            <small className="text-muted">Submission Date</small>
                                                                            <small className="text-muted">
                                                                                <strong>10 Nov 20</strong>
                                                                            </small>
                                                                        </div>
                                                                        <div className="d-flex justify-content-center mt-3">
                                                                            <button
                                                                                className="btn btn-primary w-100"
                                                                                style={{ borderRadius: 5 }}
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#objectivetest"
                                                                            >
                                                                                Start Test
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className='no-data-img'>
                                                                <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                            </div>
                                                        }
                                                        <div className="col-lg-6 col-md-6 col-sm-6 mt-3 col-md-6">
                                                            <div
                                                                className="card bg-light"
                                                                style={{
                                                                    borderRadius: 10,
                                                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
                                                                }}
                                                            >
                                                                <div className="card-body p-3">
                                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                                        <div>
                                                                            <span className="badge me-2 bg-danger text-white">
                                                                                Subjective
                                                                            </span>
                                                                            <span className="badge me-2 bg-success text-white">
                                                                                Mock Assignment
                                                                            </span>
                                                                            <span className="badge me-2 bg-primary text-white">
                                                                                Mathematics
                                                                            </span>
                                                                        </div>
                                                                        {/* <small class="text-muted"><i class="fas fa-clock"></i> Due
                                                          in 2 Days</small> */}
                                                                    </div>
                                                                    <h5 className="mb-1" style={{ fontWeight: "bold" }}>
                                                                        Surface Areas and Volumes
                                                                    </h5>
                                                                    <div className="d-flex justify-content-between">
                                                                        <small className="text-muted">Assign Date</small>
                                                                        <small className="text-muted">
                                                                            {" "}
                                                                            <strong>10 Nov 20</strong>
                                                                        </small>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between">
                                                                        <small className="text-muted">Submission Date</small>
                                                                        <small className="text-muted">
                                                                            <strong>10 Nov 20</strong>
                                                                        </small>
                                                                    </div>
                                                                    <div className="d-flex justify-content-center mt-3">
                                                                        <button
                                                                            className="btn btn-primary w-100"
                                                                            style={{ borderRadius: 5 }}
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#subjectivetest"
                                                                        >
                                                                            Start Test
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>}
                                            </div>
                                        </div>
                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            <div className="my-schedule-detail-sec">
                                                {loadingStudentUpcomingAssListApi ?
                                                    <Beatloader />
                                                    :
                                                    <div className="row">
                                                        {StudentUpcomingAssListApiData?.length ?
                                                            StudentUpcomingAssListApiData?.map((data) => (
                                                                <div className="col-lg-6 col-md-6 col-sm-6 mt-3 col-md-6">
                                                                    <div
                                                                        className="card bg-light"
                                                                        style={{
                                                                            borderRadius: 10,
                                                                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
                                                                        }}
                                                                    >
                                                                        <div className="card-body p-3">
                                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                                <div>
                                                                                    <span className="badge me-2 bg-danger text-white">
                                                                                        {data?.question_type ? 'Subjective' : 'Objective'}
                                                                                    </span>
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{data?.course?.name}</Tooltip>}>
                                                                                        <span className="badge me-2 bg-primary text-white" style={{ width: '100px', overflowX: 'clip', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                                                            {data?.course?.name}
                                                                                        </span>
                                                                                    </OverlayTrigger>
                                                                                </div>
                                                                                <small className="text-muted">
                                                                                    <i className="fas fa-clock me-1" />{date_diff_indays(data?.assesment_submit_date) == '0' ? `Due today` : `Due in ${ date_diff_indays(data?.assesment_submit_date) } Days`}
                                                                                </small>
                                                                            </div>
                                                                            <h5 className="mb-1" style={{ fontWeight: "bold" }}>
                                                                                {data?.assesment_name}
                                                                            </h5>
                                                                            <div className="d-flex justify-content-between">
                                                                                <small className="text-muted">Assign Date</small>
                                                                                <small className="text-muted">
                                                                                    {" "}
                                                                                    <strong>{data?.assesment_date}</strong>
                                                                                </small>
                                                                            </div>
                                                                            <div className="d-flex justify-content-between">
                                                                                <small className="text-muted">Submission Date</small>
                                                                                <small className="text-muted">
                                                                                    <strong>{data?.assesment_submit_date}</strong>
                                                                                </small>
                                                                            </div>
                                                                            <div className="d-flex justify-content-center mt-3">
                                                                                <button
                                                                                    className="btn btn-primary w-100"
                                                                                    style={{ borderRadius: 5 }}
                                                                                    onClick={() => { handleStartTestClick(data) }}
                                                                                >
                                                                                    Start Test
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                            :
                                                            <div className='no-data-img'>
                                                                <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                            </div>
                                                        }

                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="profile"
                                            role="tabpanel"
                                            aria-labelledby="profile-tab"
                                        >
                                            <div className="my-schedule-detail-sec">
                                                {loadingStudentCompletedAssListApi ?
                                                    <Beatloader />
                                                    :
                                                    <div className="row">
                                                        {StudentCompletedAssListApiData?.length ?
                                                            StudentCompletedAssListApiData?.map((data) => (
                                                                <div className="col-lg-6 col-md-6 col-sm-6 mt-3 col-md-6">
                                                                    <div className="card bg-light">
                                                                        <div className="card-body">
                                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                                <div>
                                                                                    <span className="badge me-2 bg-danger text-white">
                                                                                        {data?.question_type ? 'Subjective' : 'Objective'}
                                                                                    </span>
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{data?.course?.name}</Tooltip>}>
                                                                                        <span className="badge me-2 bg-primary text-white" style={{ width: '100px', overflowX: 'clip', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                                                            {data?.course?.name}
                                                                                        </span>
                                                                                    </OverlayTrigger>
                                                                                </div>
                                                                                <small className="text-muted">
                                                                                    <strong className='text-success'>Completed</strong>
                                                                                </small>
                                                                            </div>
                                                                            {/* <div className="d-flex justify-content-end">
                                                                                <h6>Assessment Name : {data?.assesment_name}</h6>
                                                                                <span className="text-success">
                                                                                    <strong>Completed</strong>
                                                                                </span>
                                                                            </div> */}
                                                                            <h5 className="mb-1" style={{ fontWeight: "bold" }}>
                                                                                {data?.assesment_name}
                                                                            </h5>
                                                                            <div className="d-flex justify-content-between">
                                                                                <small className="text-muted">Assign Date</small>
                                                                                <small className="text-muted">
                                                                                    {" "}
                                                                                    <strong>{data?.assesment_date}</strong>
                                                                                </small>
                                                                            </div>
                                                                            <div className="d-flex justify-content-between">
                                                                                <small className="text-muted">Submission Date</small>
                                                                                <small className="text-muted">
                                                                                    <strong>{data?.assesment_submit_date}</strong>
                                                                                </small>
                                                                            </div>
                                                                            <div className="d-flex justify-content-center mt-3">
                                                                                <button
                                                                                    className="btn btn-primary w-100"
                                                                                    onClick={() => { handleGradeModalClick(data) }}
                                                                                >
                                                                                    Result
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            ))
                                                            :
                                                            <div className='no-data-img'>
                                                                <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                            </div>
                                                        }

                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>



            <>

                <div
                    className="modal fade logout-modal"
                    id="suresubmit"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div
                                className="modal-body my-4"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <p>Are you sure you want to Submit?</p>
                                <div className="modal-footer">
                                    <a href="./assignments.html">
                                        <button type="button" className="btn btn-primary">
                                            Submit
                                        </button>
                                    </a>
                                    <a href="./StudentDashboard.html">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-bs-dismiss="modal"
                                        >
                                            Cancel
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* objective test */}
                <Modal
                    className="tutor-details-modal"
                    id="objectivetest"

                    show={showObjectiveModal}
                    onHide={() => { setShowObjectiveModal(false); setloadObjectiveModalData(true) }}
                >


                    <ModalHeader closeButton >
                        <ModalTitle>Objective Test</ModalTitle>
                    </ModalHeader>


                    <ModalBody>
                        {loadObjectiveModalData ?
                            <Beatloader />
                            :
                            <>
                                <div className="row mb-3">
                                    <div className="col-lg-4 col-md-4 ">
                                        <img
                                            src={`${ host }${ objectiveModalData?.tutor?.profile_img }`}

                                            onError={(e) => {
                                                e.target.src = '/assets/img/user/user.png'; // Fallback image
                                            }}
                                            className="img-fluid rounded-circle"
                                            style={{ height: "6rem", width: "auto" }}
                                        />
                                    </div>
                                    <div className="col-lg-5 col-md-5">
                                        <h6 className="mb-0">{objectiveModalData?.tutor?.name}</h6>

                                        <h6>Assessment Name : <small> {objectiveModalData?.assesment_name}</small></h6>
                                        <h6>Course Name :<small> {objectiveModalData?.course?.name}</small></h6>

                                    </div>
                                    <div className="col-lg-3 text-end">
                                        <p className="text-muted text-end">
                                            <i className="bi bi-clock me-1" />
                                            {objectiveModalData?.duration} min
                                        </p>
                                    </div>
                                </div>
                                <div className="row ">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Grade</p>
                                        <h6>{objectiveModalData?.course?.category?.name}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Subject</p>
                                        <h6>{objectiveModalData?.course?.subcategory?.name}</h6>
                                    </div>
                                    <div className="col-lg-12">
                                        <p className="text-muted mb-0">Topic</p>
                                        <h6>{objectiveModalData?.course?.childcategory?.name}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">No. of Questions</p>
                                        <h6>{objectiveModalData?.no_of_question}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Total Marks</p>
                                        <h6>{objectiveModalData?.total_marks}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Duration</p>
                                        <h6>{objectiveModalData?.duration} Min</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Day</p>
                                        <h6>{objectiveModalData?.assesment_day}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Assign Date</p>
                                        <h6>{objectiveModalData?.assesment_date}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Submit Date</p>
                                        <h6>{objectiveModalData?.assesment_submit_date}</h6>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center mt-3">
                                    <button
                                        className="btn btn-primary w-100"
                                        style={{ borderRadius: 5 }}
                                        onClick={() => handleObjectiveTestModalClick(objectiveModalData)}
                                    >
                                        Start Test
                                    </button>
                                </div>
                            </>}
                    </ModalBody>

                </Modal>
                <Modal
                    className="tutor-details-modal"
                    id="subjectivetest"
                    show={showSubjectiveModal}
                    onHide={() => { setShowSubjectiveModal(false); setloadSubjectiveModalData(true) }}
                >

                    <ModalHeader closeButton >
                        <ModalTitle>Subjective Test</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        {loadSubjectiveModalData ?
                            <Beatloader />
                            :
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row mb-3">
                                    <div className="col-lg-4 col-md-4 ">
                                        <img
                                            src={`${ host }${ subjectiveModalData?.tutor?.profile_img }`}

                                            onError={(e) => {
                                                e.target.src = '/assets/img/user/user.png'; // Fallback image
                                            }}
                                            className="img-fluid rounded-circle"
                                            style={{ height: "6rem", width: "auto" }}
                                        />
                                    </div>
                                    <div className="col-lg-5 col-md-5">
                                        <h6 className="mb-0">{subjectiveModalData?.tutor?.name}</h6>

                                        <h6>Assessment Name : <small> {subjectiveModalData?.assesment_name}</small></h6>
                                        <h6>Course Name :<small> {subjectiveModalData?.course?.name}</small></h6>
                                        <div className="d-flex justify-content-center mt-3">
                                            <a

                                                href={`${ host }/${ subjectiveModalData?.subjective_questions?.[0]?.file }`}
                                                // download="subjective-test"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-primary w-100"
                                                style={{ borderRadius: 5 }}
                                            >
                                                View/Download
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 text-end">
                                        <p className="text-muted text-end">
                                            <i className="bi bi-clock me-1" />
                                            {subjectiveModalData?.duration} min
                                        </p>
                                    </div>
                                </div>
                                <div className="row ">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Grade</p>
                                        <h6>{subjectiveModalData?.course?.category?.name}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Subject</p>
                                        <h6>{subjectiveModalData?.course?.subcategory?.name}</h6>
                                    </div>
                                    <div className="col-lg-12">
                                        <p className="text-muted mb-0">Topic</p>
                                        <h6>{subjectiveModalData?.course?.childcategory?.name}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">No. of Questions</p>
                                        <h6>{subjectiveModalData?.no_of_question}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Total Marks</p>
                                        <h6>{subjectiveModalData?.total_marks}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Duration</p>
                                        <h6>{subjectiveModalData?.duration} Min</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Day</p>
                                        <h6>{subjectiveModalData?.assesment_day}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Assign Date</p>
                                        <h6>{subjectiveModalData?.assesment_date}</h6>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <p className="text-muted mb-0">Submit Date</p>
                                        <h6>{subjectiveModalData?.assesment_submit_date}</h6>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <input
                                            type="file"
                                            accept=".pdf,.doc,.docx,.jpg,.png"
                                            className="btn btn-primary"
                                            onChange={(e) => { handleFileChange(e, subjectiveModalData?.id) }} // Trigger file selection logic
                                        />
                                        {formik.errors.assessment_file && formik.touched.assessment_file && (
                                            <div style={{ color: "red", fontSize: "12px" }}>
                                                {formik.errors.assessment_file}
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-md-12">
                                        <button
                                            type="button"
                                            className="btn btn-primary w-100"
                                            style={{ borderRadius: 5 }}
                                            onClick={async () => {
                                                const errors = await formik.validateForm();

                                                if (!formik.values.assessment_file) {
                                                    toast.error("Please upload assessment file");
                                                    return;
                                                }

                                                if (Object.keys(errors).length > 0) {
                                                    return;
                                                }

                                                formik.handleSubmit();
                                            }}
                                        >
                                            {formik.isSubmitting ? <HourglassLoader /> : 'Upload Test'}
                                        </button>
                                    </div>
                                </div>
                            </form>}
                    </ModalBody>

                </Modal>
                {/* grade results */}
                <Modal
                    className='modal border-0 logout-modal'
                    show={showGradeModal}
                    onHide={() => { setShowGradeModal(false); setloadgradeData(true) }}
                >



                    <Modal.Header closeButton />
                    <Modal.Body
                        className=" my-0"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        {loadgradeData ?
                            <Beatloader />
                            :
                            <><div
                                className="border rounded-circle bg-primary text-white mb-3"
                                style={{
                                    height: "8rem",
                                    width: "8rem",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <h4>{gradeData?.result?.percentage}</h4>
                                <h5>Grade {gradeData?.result?.grade}</h5>
                            </div><h6 className="mb-3">{gradeData?.result?.remarks}</h6>
                                {/* <h5 className="mb-3">Deepika Kumari</h5> */}
                                <div className="card bg-primary w-100">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-sm-6 border-end border-white">
                                                <h6 className="mb-0 text-center text-white">Total Marks</h6>
                                                <h6 className="mb-0 text-center text-white">{gradeData?.total_marks}</h6>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6">
                                                <h6 className="mb-0 text-center text-white">
                                                    Obtained Marks
                                                </h6>
                                                <h6 className="mb-0 text-center text-white">{gradeData?.marks_obtained?.marks}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div></>}
                    </Modal.Body>

                </Modal>
                {/* Test Modal */}
                <StudentTestModal ObjectiveTestModalData={ObjectiveTestModalData} loadObjectiveTestModalData={loadObjectiveTestModalData} showObjectiveTestModal={showObjectiveTestModal} handleClose={handleClose} />
            </>


        </div>
    )
}

export default StudentMyAssignments